import styles from "./UnreadBadge.module.css";

export type UnreadBadgeProps = {
  count: number | null | undefined;
  label?: string;
};

/** Unread alert count: a red callout bubble when > 0, a green bold "0" otherwise. */
export const UnreadBadge = ({ count, label = "unread alerts" }: UnreadBadgeProps) => {
  const n = count ?? 0;
  return n > 0 ? (
    <output className={styles.bubble} aria-label={`${n} ${label}`}>
      {n > 99 ? "99+" : n}
    </output>
  ) : (
    <output className={styles.zero} aria-label={`no ${label}`}>
      0
    </output>
  );
};
